import { makeStyles } from "@material-ui/core/styles";
import CallIcon from "@material-ui/icons/Call";
import CallEndIcon from "@material-ui/icons/CallEnd";
import axios from "axios";
import React, { useState } from "react";
import useAuth from "../../../../../../../hooks/auth";
import { formatPhoneNumber } from "../../../../../../../utils/formatters";
import { Button } from "../../../../../../ui";
import DataCell from "./data";

const useStyles = makeStyles({
  root: {
    height: "18px",
    width: "18px",
    color: "#0066FF",
    marginTop: "-8px",
    position: "relative",
    bottom: "-3px",
  },
  button: {
    margin: "0 24px",
  },
});

const PhoneCell = ({ value, label }) => {
  const [isCalling, setIsCalling] = useState(false);
  const classes = useStyles();
  const { user } = useAuth();
  const canCall = user.modules.includes("total_voice");

  const handleClick = (value) => {
    setIsCalling(true);

    if (!isCalling) {
      axios.get(`/users/${user.id}/make_call/${value}`).then(({ data }) => {
        if (!data.sucesso) {
          setIsCalling(false);
          alert("Erro ao realizar a ligação");

          return;
        }

        setIsCalling(true);

        const newTab = window.open(data.dados["url"], "_blank");

        var timer = setInterval(() => {
          if (newTab.closed) {
            setIsCalling(false);

            clearInterval(timer);
          }
        }, 1000);
      });
    }
  };

  return (
    <DataCell
      label={label}
      xs={12}
      value={
        <>
          {formatPhoneNumber(value)}

          {canCall && (
            <Button
              onClick={() => handleClick(value)}
              variant="text"
              className={classes.button}
              endIcon={
                isCalling ? (
                  <CallEndIcon classes={{ root: classes.root }} />
                ) : (
                  <CallIcon classes={{ root: classes.root }} />
                )
              }
            >
              {isCalling ? "Em ligação" : "Ligar"}
            </Button>
          )}
        </>
      }
    />
  );
};

export default PhoneCell;
